<template>
  <z-dialogo ref="dialogo" titulo="Imprimir Etiquetas" :dividers="true" largura="500px" persistent>
    <template #texto>
      <v-row dense>
        <v-col cols="12">
          <z-select 
            v-model="modelo"
            label="Modelo Etiqueta"
            :items="$globals.MODELOS_ETIQUETAS"
            :rules="[v => !!v || 'Selecione um modelo']"
          ></z-select>
        </v-col>
        <v-col cols="12" v-if="exibirQuantidade">
          <z-campo-valor
            v-model="quantidade"
            label="Quantidade"
            number
            decimais="0"
            :rules="[v => !!v || 'Informe a quantidade']"
          ></z-campo-valor>
        </v-col>
      </v-row>
    </template>

    <template #actions_right>
      <v-btn text @click="$refs.dialogo.fechar()">
        Cancelar
      </v-btn>
      <v-btn depressed color="primary" @click="imprimir">
        <v-icon left>mdi-printer</v-icon>
        Imprimir
      </v-btn>
    </template>
  </z-dialogo>
</template>

<script>
// import { MESES } from '@/app/globals';

export default {
  name: 'ModeloEtiqueta',

  props: {
    relatorio: {
      type: String,
      default: '',
    },
    exibirQuantidade: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      modelo: '100x30x01',
      quantidade: 1,
      resolve: null,
      reject: null,
    };
  },

  methods: {
    async abrir() {
      // this.modelo = '100x30x01';
      this.$refs.dialogo.abrir();
      this.quantidade = 1;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    fechar() {
      this.resolve(false);
      this.$refs.dialogo.fechar();
    },

    imprimir() {
      this.resolve({
        modelo: this.modelo,
        quantidade: this.quantidade,
      });
      // this.$emit('imprimir', this.modelo);
      this.fechar();
    },
  },
};
</script>

<style scoped></style>
